import { endPoints, requestType } from "../../constants/Variables";
import Api from "../index";

const getAllWorkersAppointment = (id, status = "All") => {
  return Api(
    `${endPoints.getAppointmentsByWorkerId}/${id}?status=${status}`,
    null,
    requestType.GET
  );
};

const getWorkerUpcommingJobs = (id) => {
  return Api(
    `${endPoints.getWorkerUpcommingJobs}/${id}`,
    null,
    requestType.GET
  );
};

const getWorkerForFilters = (id) => {
  return Api(endPoints.getWorkerForFilters, null, requestType.GET);
};

export {
  getAllWorkersAppointment,
  getWorkerUpcommingJobs,
  getWorkerForFilters,
};
